import { useCallback } from 'react';

import { useAnalytics } from 'context/analytics';
import { useBezelUser } from 'context/bezelUser';
import { logGTMMaxBidStarted, logMaxBidStarted } from 'lib/events';
import { Listing } from 'types';

export const useLogBidStarted = (listing: Listing) => {
  const analytics = useAnalytics();
  const { user } = useBezelUser();

  const logAnalytics = useCallback(() => {
    logMaxBidStarted(analytics, listing);
    logGTMMaxBidStarted(listing, user);
  }, [analytics, listing, user]);

  return logAnalytics;
};
